import React, {useEffect, useState} from 'react';
import StartAffirmButton from './StartAffirmButton';
import SaveCartButton from './SaveCartButton';
import PaypalCheckoutButton from './PaypalCheckoutButton';
import CheckoutPath from "../../services/CheckoutPath";
import {applePayAvailable} from "../../services/applePayHelpers";
import {getEnabledPaymentTypes} from "../../services/cartConfig";
import AlternatePayment from "./AlternatePayment";
import ApplePayButton from "../../../Checkout/components/payment/ApplePayButton";
import PrimaryCheckoutButton from "./PrimaryCheckoutButton";
import {isCheckoutDisabled} from "../../../Checkout/logic/checkout";
import {useNonEmptyContext} from "../../../lib/hooks";
import {CartConfigContext} from "../../../contexts/CartConfigContext";

export default function CartSidebarButtonBox(props) {
  let {
    cartCode, shoppingCart = {}, currentAgent,
    checkoutPath, enableAffirm = false, dispatch
  } = props;

  const cartConfig = useNonEmptyContext(CartConfigContext);

  checkoutPath || (checkoutPath = getCheckoutPath(cartCode, shoppingCart));

  const [applePayExists, setApplePayExists] = useState(false);

  useEffect(() => {setApplePayExists(applePayAvailable())}, []);

  let ptList = getEnabledPaymentTypes({
    shoppingCart, currentAgent, cartConfig
  });

  const paymentTypes = _.keyBy(ptList, x => x);

  const checkoutDisabled = isCheckoutDisabled(cartConfig);

  return (<div id="cart-sidebar-button-box">
    <SaveCartButton {...props} />

    {!checkoutDisabled && <PrimaryCheckoutButton
      shoppingCart={shoppingCart}
      cartCode={cartCode}
      checkoutPath={checkoutPath}/>}

    {!checkoutDisabled && <div id="other-checkouts">
      <AlternatePayment visible={paymentTypes['affirm'] && enableAffirm}>
        <StartAffirmButton
          {...props} checkoutPath={checkoutPath}/>
      </AlternatePayment>

      <AlternatePayment visible={applePayExists && paymentTypes['apple']}>
        <ApplePayButton {...props}
          checkoutPath={checkoutPath} dispatch={dispatch}/>
      </AlternatePayment>

      <AlternatePayment visible={paymentTypes['paypal']}>
        <PaypalCheckoutButton cartCode={cartCode}
          shoppingCart={shoppingCart}
        />
      </AlternatePayment>
    </div>}
  </div>);

}

function getCheckoutPath(cartCode, shoppingCart) {
  let cp = new CheckoutPath({
    cartCode, cart: shoppingCart
  })
  return cp.toString()
}
